import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classnames';
import { TouchableDiv } from '@components/common/Touchable';
import { getObjectValue } from '@utility/utills';
import { setFunctionModifierId } from '@reducers/orders';

const CONTAINER_STYLE_BASE = { zIndex: '9' };
const MODIFIER_TEXT_STYLE = { width: '90px' };

const ModFunctionPill = React.memo(
  ({ data, modifiersHashTable, isActive, serverAppTheme, onClick }) => {
    const name =
      data.name || modifiersHashTable[data.modifierId]?.name || '';
    const hasName = getObjectValue(() => Boolean(name), false);

    if (!hasName) return null;

    const displayName =
      name.length > 8 ? name.substring(0, 9) : name;

    return (
      <TouchableDiv
        className="pr-1 pl-0 pb-10 d-flex"
        role="presentation"
        onClick={onClick}
        rippleEffect={true}
      >
        <TouchableDiv
          className={cn(
            isActive ? 'color-white' : '',
            'px-2 py-1 position-relative d-flex align-items-center justify-content-center'
          )}
          style={{
            backgroundColor: isActive
              ? serverAppTheme?.selected
              : 'transparent',
              border: isActive ? 'none' : '1px solid #BEBEBE',
              borderRadius: '4px',
              height: '28px',
          }}
          rippleEffect={true}
        >
          <div
            className="text-center fs_12 fw-600"
            style={{
              ...MODIFIER_TEXT_STYLE,
              color: serverAppTheme?.primary_text,
            }}
          >
            {displayName}
          </div>
        </TouchableDiv>
      </TouchableDiv>
    );
  }
);


const ModFunctionBar = React.memo(
  ({
    modFunctionModifierGroupId,
    modifierGroupsHashTable,
    modifiersHashTable,
    functionModifierId,
    serverAppTheme,
    setFunctionModifierId,
  }) => {
    const group = modFunctionModifierGroupId
      ? modifierGroupsHashTable[modFunctionModifierGroupId]
      : null;

    const handlePillClick = useCallback(
      modifierId => {
        setFunctionModifierId(
          modifierId === functionModifierId ? null : modifierId
        );
      },
      [functionModifierId, setFunctionModifierId]
    );

    if (!group) return null;

    return (
      <div
        className="px-0 d-flex flex-row w-100 overflowX pt-1 mt-sm-n1"
        style={{
          ...CONTAINER_STYLE_BASE,
          background: serverAppTheme?.background_color,
        }}
      >
        {group.modifierLinks.map(data => {
          const isActive = functionModifierId === data.modifierId;
          return (
            <ModFunctionPill
              key={data.modifierId}
              data={data}
              modifiersHashTable={modifiersHashTable}
              isActive={isActive}
              serverAppTheme={serverAppTheme}
              onClick={() => handlePillClick(data.modifierId)}
            />
          );
        })}
      </div>
    );
  }
);

const mapStateToProps = ({ orders, theme }) => {
  const { menusList, menuIndex } = orders;
  const modFunctionModifierGroupId =
    menusList?.[menuIndex]?.modFunctionModifierGroupId ?? null;

  return {
    modFunctionModifierGroupId,
    modifierGroupsHashTable: orders.modifierGroupsHashTable,
    modifiersHashTable: orders.modifiersHashTable,
    functionModifierId: orders.functionModifierId,
    serverAppTheme: theme.serverAppTheme,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setFunctionModifierId }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModFunctionBar);
